import React from "react";
import {
  getFirestore,
  collection,
  getDocs,
  query,
  where,
  doc,
  getDoc,
} from "firebase/firestore";

import FeaturedBlogView from "../blogList/featuredBlog";
import themeLarge from "../ThemeLarge";

import { Link, useNavigate } from "react-router-dom";

class LatestBlog extends React.Component {
  constructor(props) {
    super(props);
    // Initialize the state
    this.state = {
      featuredBlog: null,
      isMobile: window.innerWidth <= 768,
    };
  }

  componentDidMount() {
    this.fetchFeaturedOrLatestBlog();
    window.addEventListener("resize", this.updateWindowSize);
  }

  // Remove event listener when the component unmounts to avoid memory leaks
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowSize);
  }

  // fetches the featured/latest blog
  fetchFeaturedOrLatestBlog = async () => {
    const db = getFirestore();

    try {
      // ✅ Try to get the featured blog first
      const featuredDocRef = doc(db, "featured", "current");
      const featuredDocSnap = await getDoc(featuredDocRef);
      const featuredBlogId = featuredDocSnap.exists()
        ? featuredDocSnap.data().blogId
        : null;

      let blogToShow = null;

      if (featuredBlogId) {
        // 🔥 If a featured blog ID exists, fetch it
        const blogDocRef = doc(db, "blogs", featuredBlogId);
        const blogDocSnap = await getDoc(blogDocRef);
        if (blogDocSnap.exists() && blogDocSnap.data().status === "published") {
          blogToShow = { id: blogDocSnap.id, ...blogDocSnap.data() };
        }
      }

      if (!blogToShow) {
        // 🚨 No featured blog or it was invalid — fetch latest published blog
        const q = query(
          collection(db, "blogs"),
          where("status", "==", "published")
        );
        const querySnapshot = await getDocs(q);
        const allBlogs = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        if (allBlogs.length > 0) {
          // 🕰️ Sort by createdAt descending (newest first)
          allBlogs.sort(
            (a, b) => b.createdAt.toMillis() - a.createdAt.toMillis()
          );
          blogToShow = allBlogs[0];
        }
      }

      // 🌟 Finally set featuredBlog state
      this.setState({
        featuredBlog: blogToShow,
      });
    } catch (error) { }
  };

  handleCardClick = (slug) => {
    const { navigate } = this.props;
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(`/blogs/${slug}`);
  };

  render() {
    const { isMobile } = this.state;
    return (
      <div
        className="pt-2 pb-2"
        style={{
          background: isMobile ? themeLarge.colors.secondary : themeLarge.colors.bg,
          paddingLeft: isMobile ? "10px" : "100px",
          paddingRight: isMobile ? "10px" : "100px",
          fontFamily: "Kumbh Sans",
        }}
      >
        <div className="container">
          <p
            className="d-flex justify-content-center"
            style={{
              color: themeLarge.colors.text,
              fontSize: isMobile ? themeLarge.fontSize.h3 : themeLarge.fontSize.h2,
            }}
          >
            {" "}
            Recent Blog{" "}
          </p>
          <FeaturedBlogView
            featuredBlog={this.state.featuredBlog}
            onClick={() => this.handleCardClick(this.state.featuredBlog?.slug)}
          />{" "}
        </div>
      </div>
    );
  }
}

// Higher-order component to use navigation
function withNavigation(Component) {
  return function Wrapper(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
  };
}

export default withNavigation(LatestBlog);
